var exports = {
  "fm": "PinnedCommentContainer__4U4tvG",
  "fR": "PinnedCommentHeader___SHuFn",
  "I2": "PinnedByInfo__xSnvQ0",
  "Tm": "PinnedByIcon__FIVtm_",
  "JP": "ActionsMenuButton__mLEY8e",
  "at": "AuthorInfo__OCAJBH",
  "Qi": "AuthorLink__3XQv9-",
  "eu": "Avatar__ezI3kT",
  "w4": "CommentBody__S4Xtxj",
  "Th": "FullCommentLink__N3eOiA",
  "xD": "TimestampLink__4xu_3S",
  "lX": "HeaderActions__BIWhV0",
};

module.exports = exports;
